import { apiPost } from './http-client';

export type PurchasePlanResponse = {
  id: number;
  subscription_plan_id: number;
  plan_name: string;
  plan_type: string;
  status: string;
  payment_url: string | null;
};

/** POST /api/v1/subscriptions/subscription-plans/{plan_id}/purchase */
export function purchaseSubscriptionPlan(
  planId: number,
  accessToken: string,
  returnUrl: string | null
): Promise<PurchasePlanResponse> {
  return apiPost<PurchasePlanResponse>(
    `/api/v1/subscriptions/subscription-plans/${planId}/purchase`,
    returnUrl ? { return_url: returnUrl } : {},
    { accessToken }
  );
}
